export default __webpack_public_path__ + "static/media/tree.1d45ee2e.png";